import { printCourseWisePaymentApi, printCustomerReceiptApi, printKitchenReceiptApi, printSplitPaymentApi } from "@/api/take-order/take-order";
import { printConcessionSlip } from "@/api/new-api/order-history/order-history";
import { toast } from "react-hot-toast";

export function printConcessionCopy(concessionId) {
    if (!concessionId) {
        toast.error("Concession ID is missing.");
        return Promise.resolve({ status: "failure", message: "Concession ID is missing." });
    }

    return printConcessionSlip(concessionId).then((res) => {
        if (res?.status === "success" || res?.status === "Success" || !res?.status) {
            toast.success(res?.message || "Concession slip printed successfully");
        } else {
            toast.error(res?.message || "Failed to print concession slip");
        }
        return res;
    }).catch((err) => {
        console.error("Error printing concession slip:", err);
        toast.error("An error occurred while printing the concession slip");
        return { status: "failure", message: "An error occurred while printing the concession slip" };
    });
}

export function printKitchenCopy(orderId, options = {}) {
    const printerId = options?.printerId;
    const itemIds = options?.itemIds || [];

    return printKitchenReceiptApi(orderId, printerId, itemIds).then((res) => {
        if(res?.status == "success"){
            toast.success("Kitchen receipt printed successfully");
        }else{
            toast.error(res?.message || "Failed to print kitchen receipt");
        }
        return res;
    }).catch((err) => {
        console.error("Error printing kitchen receipt:", err);
        toast.error("An error occurred while printing the kitchen receipt");
        return { status: "failure", message: "An error occurred while printing the kitchen receipt" };
    });
}


export function printCustomerCopy(orderId, printerId) {
    return printCustomerReceiptApi(orderId, printerId).then((res) => {
        if(res?.status == "success"){
            toast.success("Customer receipt printed successfully");
        }else{
            toast.error(res?.message || "Failed to print customer receipt");
        }
        return res;
    }).catch((err) => {
        console.error("Error printing customer receipt:", err);
        toast.error("An error occurred while printing the customer receipt");
        return { status: "failure", message: "An error occurred while printing the customer receipt" };
    });
}

export function printSplitPaymentCopy(orderId, splitPaymentId, printerId) {
    return printSplitPaymentApi(orderId, splitPaymentId, printerId).then((res) => {
        if(res?.status == "success"){
            toast.success("Split payment receipt printed successfully");
        }else{
            toast.error(res?.message || "Failed to print split payment receipt");
        }
        return res;
    }).catch((err) => {
        console.error("Error printing split payment receipt:", err);
        toast.error("An error occurred while printing the split payment receipt");
        return { status: "failure", message: "An error occurred while printing the split payment receipt" };
    });
}

export function printCourseWisePaymentCopy(restaurantId, orderId, courseWisePaymentId, printerId) {
    return printCourseWisePaymentApi(restaurantId, orderId, courseWisePaymentId, printerId).then((res) => {
        if(res?.status == "success"){
            toast.success("Course-wise payment receipt printed successfully");
        }else{
            toast.error(res?.message || "Failed to print course-wise payment receipt");
        }
        return res;
    }).catch((err) => {
        console.error("Error printing course-wise payment receipt:", err);
        toast.error("An error occurred while printing the course-wise payment receipt");
        return { status: "failure", message: "An error occurred while printing the course-wise payment receipt" };
    });
}

